// Back to top (.btt): appears after 0.8 viewport of scroll; lifts above the Cha Maker sticky bar (html.bar-on).
const b = document.querySelector('.btt');
if (b) {
  let raf = 0;
  const tick = () => { raf = 0; b.classList.toggle('on', window.scrollY > window.innerHeight * 0.8); };
  window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
  tick();
  b.addEventListener('click', () => {
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    document.getElementById('MainContent')?.focus({ preventScroll: true });
  });
}
